import { render } from "./ReservationTicketPrintPreview.vue?vue&type=template&id=801becd8&scoped=true"
import script from "./ReservationTicketPrintPreview.vue?vue&type=script&lang=js"
export * from "./ReservationTicketPrintPreview.vue?vue&type=script&lang=js"

import "./ReservationTicketPrintPreview.vue?vue&type=style&index=0&id=801becd8&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801becd8"]])

export default __exports__